function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "27.5634354 0 0 15.91329 27.5634354 31.8277285 55.1268708 15.91329"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u5B9A\\u7A3F",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u9F99\\u8725\\u5B9E\\u9A8C\\u5BA4",
  transform: "translate(-933.000000, -1359.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-7",
  transform: "translate(0.000000, 1166.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "decorative-icon-safety",
  transform: "translate(933.000000, 193.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-1",
  fill: "#C3C5C6",
  fillRule: "nonzero",
  points: "0 0 0 15.91329 27.5634354 31.8277285 27.5634354 64 27.6231562 63.9701396 27.6231562 4.5939059 27.5634354 0"
}), /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4",
  transform: "translate(0.000000, 0.010336)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,15.9036428 L0,41.3355059 L0,41.6903851 C0,46.9102107 2.94928759,51.6821304 7.61899293,54.0181316 L27.5634354,63.9892043 L27.5634354,31.8169329 L0,15.9036428 Z",
  id: "Fill-2",
  fill: "#A1CDF4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.4600725,22.2848078 L11.4600725,37.142648 L11.4600725,37.3505222 C11.4600725,40.3997272 13.1827872,43.1882281 15.9104188,44.5514697 L27.5628611,50.3776908 L27.5628611,31.5817249 L11.4600725,22.2848078 Z",
  id: "Fill-4",
  fill: "#EBECEC"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-6",
  fill: "#181818",
  points: "27.6229265 0 27.6229265 31.7829379 55.1266411 15.9041022 55.1266411 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.6229265,63.9602627 L47.5076481,54.0179019 C52.1773535,51.6830492 55.1266411,46.909981 55.1266411,41.6901554 L55.1266411,41.3352762 L55.1266411,15.9034131 L27.6229265,31.7833973 L27.6229265,63.9602627 Z",
  id: "Fill-8",
  fill: "#62B2F9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.7261745,22.4194093 L43.7261745,37.2772494 L43.7261745,37.4851236 C43.7261745,40.5343287 42.0034598,43.3228296 39.2746797,44.6860711 L27.6233859,50.5122923 L27.6233859,31.7163263 L43.7261745,22.4194093 Z",
  id: "Fill-10",
  fill: "#BFDCF5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Fill-12-Clipped",
  transform: "translate(0.000000, 0.000230)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "path-1"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-12",
  fill: "#1C8AEC",
  fillRule: "nonzero",
  mask: "url(#mask-2)",
  points: "27.5634354 0 0 15.91329 27.5634354 31.8277285 55.1268708 15.91329"
}))))));

function SvgDecorativeIcon4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "64px",
    viewBox: "0 0 56 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5B89\u5168\u670D\u52A1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecorativeIcon4);
export default __webpack_public_path__ + "static/media/decorative-icon-4.250da720.svg";
export { ForwardRef as ReactComponent };